import { RemoteConfigVariables } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { Button, ButtonTypes } from '../components';
import Theme from '../theme';
import { RemoteConfigWrapper } from '../ui/components/RemoteConfigWrapper';
import { defaultScale } from '../utils/scaling';
import { isMobile, isWeb } from '../utils/ScreenSizes';
import { openLink } from '../utils/linkUtils';

interface IProps {
  navigation?: any;
  renderInviteText: () => any;
  landingPage: string | undefined;
  workoutInviteId: string | undefined;
  utm_source: string | undefined;
  t(key: string, options?: any): string;
}

interface IState {
  socialSignupButtonsVisible: boolean;
}

class HomeInviteButtonsContainerComponent extends PureComponent<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      socialSignupButtonsVisible: false,
    };
  }

  public getStartedPressed = async () => {
    if (this.props.landingPage) {
      let url = this.props.landingPage;

      if (this.props.workoutInviteId) {
        const queryParam = `workoutInviteId=${this.props.workoutInviteId}`;
        url = `${url}${url.includes('?') ? '&' : '?'}${queryParam}`;
      }

      if (this.props.utm_source) {
        const queryParam = `utm_source=${this.props.utm_source}`;
        url = `${url}${url.includes('?') ? '&' : '?'}${queryParam}`;
      }

      await openLink(url);
      return;
    }
    this.props.navigation.navigate('Login');
  }

  public showSignupButtons = () => {
    this.setState({
      socialSignupButtonsVisible: true,
    });
  }

  public goToLogin = () => {
    this.props.navigation.navigate(isWeb() ? 'HomeInstallAppScreen' : 'Login');
  }

  public render() {
    const { t, renderInviteText } = this.props;
    const showInviteText = isWeb() && !isMobile();
    return (
      <View style={styles.buttonContainer}>
        {!isMobile && (
          <Text style={styles.header}>
            {t('inviteMessage').toUpperCase()}
          </Text>
        )}
        {showInviteText && <View style={styles.inviteTextContainer}>{renderInviteText()}</View>}
        <Button
          title={t('alreadyHaveAccountContinue')}
          containerStyle={styles.buttonStyle}
          onPress={this.goToLogin}
          buttonType={ButtonTypes.TRANSPARENT}
          overrideFontStyles={{ fontFamily: Theme.Custom800 }}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  buttonContainer: {
    padding: defaultScale(15),
    flex: 1,
    alignItems: 'center',
    justifyContent: isMobile() || !isWeb() ? 'flex-end' : 'flex-start',
  },
  header: {
    fontSize: 28,
    paddingBottom: 20,
    textAlign: 'center',
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom800,
  },
  buttonStyle: {
    maxWidth: defaultScale(410),
    width: '100%',
  },
  buttonTextStyle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
  },
  inviteTextContainer:{
    maxWidth: defaultScale(500),
  },
});
export const HomeInviteButtonsContainer = translate(['auth', 'formFields'], {
  wait: true,
})(HomeInviteButtonsContainerComponent);
